import { useMemo } from 'react';
import constate from '../../common/lib/constate';
import { useMedia } from '../../common/hooks/useMedia';
import { minWidth, maxWidth } from '../constants/mediaQueries';

function useResponsive() {
  const isXs = useMedia({ maxWidth: maxWidth.XS });
  const isSm = useMedia({ minWidth: minWidth.SM, maxWidth: maxWidth.SM });
  const isMd = useMedia({ minWidth: minWidth.MD, maxWidth: maxWidth.MD });
  const isLg = useMedia({ minWidth: minWidth.LG, maxWidth: maxWidth.LG });
  const isXl = useMedia({ minWidth: minWidth.XL });

  const isSmAndBelow = useMemo(() => isXs || isSm, [isSm, isXs]);
  const isMdAndBelow = useMemo(() => isXs || isSm || isMd, [isMd, isSm, isXs]);
  const isLgAndBelow = useMemo(() => isXs || isSm || isMd || isLg, [isLg, isMd, isSm, isXs]);

  return useMemo(
    () => ({
      isLgAndBelow,
      isMdAndBelow,
      isSmAndBelow,
      isXl,
      isLg,
      isMd,
      isSm,
      isXs,
    }),
    [isLg, isLgAndBelow, isMd, isMdAndBelow, isSm, isSmAndBelow, isXl, isXs]
  );
}

export const useResponsiveContext = constate(useResponsive);

const ResponsiveContext = {
  Provider: useResponsiveContext.Provider,
};

export default ResponsiveContext;
